<template>
  <div>
    <div class="page-header">
      <div class="page-header-index-wide">
        <a-breadcrumb class="breadcrumb">
          <a-breadcrumb-item>
            <router-link :to="{ path: '/' }">首页</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>基础设置</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <span>小程序配置</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
        <div class="detail">
          <div class="main">
            <div class="row">
              <h1 class="title">小程序配置</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ak-setting :options="options" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      options: [
        {
          title: '用户协议',
          inputs: [
            {
              name: 'userAgreement',
              note: '协议内容',
              type: 'Html',
              validators: [val => (val ? null : '用户声明不可为空')]
            }
          ]
        },
        {
          title: '隐私政策',
          inputs: [
            {
              name: 'privacyPolicy',
              note: '隐私政策内容',
              type: 'Html',
              validators: [val => (val ? null : '隐私政策不可为空')]
            }
          ]
        },
        {
          title: '充值规则',
          inputs: [
            {
              name: 'rechargeRules',
              note: '规则内容',
              type: 'Html'
            }
          ]
        },
        {
          title: '返现比例',
          inputs: [
            {
              name: 'returnRadio',
              note: '返现比例(%)',
              tooltip:
                '用户缴纳物业费后按返现比例返还一定金额至用户钱包，填写0则不返现',
              type: 'Number',
              validators: [val => (val >= 0 ? null : '请输入正确的数值')]
            }
          ]
        },
        {
          title: '物业信息',
          inputs: [
            // {
            //   name: 'name',
            //   note: '物业名称',
            //   type: 'String',
            //   validators: [
            //     (val) => val ? null : '物业名称不可为空'
            //   ]
            // },
            {
              name: 'phone',
              note: '联系电话',
              type: 'String',
              validators: [val => (val ? null : '联系电话不可为空')]
            },
            {
              name: 'PropertyInformation',
              note: '地址',
              type: 'String',
              validators: [val => (val ? null : '地址不可为空')]
            }
          ]
        },
        {
          title: '时间设置',
          inputs: [
            {
              name: 'time',
              note: '截止下单时间与退款时间',
              type: 'Select',
              tooltip:
                '截止下单时间前购买的商品次日达，截止下单时间后购买的商品第三日达，当日购买的商品可以在截至下单前直接退款',
              validators: [val => (val ? null : '时间不可为空')],
              items: {
                '01:00': '01:00',
                '02:00': '02:00',
                '03:00': '03:00',
                '04:00': '04:00',
                '05:00': '05:00',
                '06:00': '06:00',
                '07:00': '07:00',
                '08:00': '08:00',
                '09:00': '09:00',
                '10:00': '10:00',
                '11:00': '11:00',
                '12:00': '12:00',
                '13:00': '13:00',
                '14:00': '14:00',
                '15:00': '15:00',
                '16:00': '16:00',
                '17:00': '17:00',
                '18:00': '18:00',
                '19:00': '19:00',
                '20:00': '20:00',
                '21:00': '21:00',
                '22:00': '22:00',
                '23:00': '23:00',
                '24:00': '24:00'
              }
            },
            {
              name: 'morning',
              note: '上午送货时间',
              type: 'Array',
              items: {
                type: 'Select',
                items: {
                  '00:00~01:00': '00:00~01:00',
                  '01:00~02:00': '01:00~02:00',
                  '02:00~03:00': '02:00~03:00',
                  '03:00~04:00': '03:00~04:00',
                  '04:00~05:00': '04:00~05:00',
                  '05:00~06:00': '05:00~06:00',
                  '06:00~07:00': '06:00~07:00',
                  '07:00~08:00': '07:00~08:00',
                  '08:00~09:00': '08:00~09:00',
                  '09:00~10:00': '09:00~10:00',
                  '10:00~11:00': '10:00~11:00',
                  '11:00~12:00': '11:00~12:00'
                }
              }
            },
            {
              name: 'afternoon',
              note: '下午送货时间',
              type: 'Array',
              items: {
                type: 'Select',
                items: {
                  '12:00~13:00': '12:00~13:00',
                  '13:00~14:00': '13:00~14:00',
                  '14:00~15:00': '14:00~15:00',
                  '15:00~16:00': '15:00~16:00',
                  '16:00~17:00': '16:00~17:00',
                  '17:00~18:00': '17:00~18:00',
                  '18:00~19:00': '18:00~19:00',
                  '19:00~20:00': '19:00~20:00',
                  '20:00~21:00': '20:00~21:00',
                  '21:00~22:00': '21:00~22:00',
                  '22:00~23:00': '22:00~23:00',
                  '23:00~24:00': '23:00~24:00'
                }
              }
            }
          ]
        },
        {
          title: '积分设置',
          inputs: [
            {
              name: 'integral',
              note: '积分比例（%）',
              tooltip: '填写10即为商品订单总金额的10%',
              type: 'Number',
              validators: [val => (val != null || val > 0 ? null : '积分百分比不可为空，且不能小于0')]
            },
            {
              name: 'deduction',
              note: '抵扣设置',
              tooltip: '积分抵扣金额(例：1000积分抵扣1元)',
              type: 'Number',
              validators: [val => (val != null && val > 0 && String(val).indexOf('.') === -1 ? null : '积分抵扣金额不可为空，且不能为小数')]
            }
          ]
        },
        {
          title: '首页轮播',
          inputs: [
            {
              name: 'banner',
              note: '轮播图',
              type: 'Array',
              items: {
                type: 'Image'
              },
              tooltip: '建议尺寸：750*300',
              validators: [val => (val && val.length > 0 ? null : '轮播图不可为空')]
            }
          ]
        },
        {
          title: '通知设置',
          inputs: [
            {
              name: 'messageUrl',
              note: '企业微信机器人通知地址',
              type: 'String'
            }
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.page-header {
  background: #fff;
  padding: 16px 32px 0;
  border-bottom: 1px solid #e8e8e8;
  margin: -24px -24px 24px -24px;
  .breadcrumb {
    margin-bottom: 16px;
  }
  .detail {
    display: flex;
    /*margin-bottom: 16px;*/
    .avatar {
      flex: 0 1 72px;
      margin: 0 24px 8px 0;
      & > span {
        border-radius: 72px;
        display: block;
        width: 72px;
        height: 72px;
      }
    }
    .main {
      width: 100%;
      flex: 0 1 auto;
      .row {
        display: flex;
        width: 100%;
        .avatar {
          margin-bottom: 16px;
        }
      }
      .title {
        font-size: 20px;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 16px;
        flex: auto;
      }
      .logo {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        margin-right: 16px;
      }
      .content,
      .headerContent {
        flex: auto;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
        .link {
          margin-top: 16px;
          line-height: 24px;
          a {
            font-size: 14px;
            margin-right: 32px;
          }
        }
      }
      .extra {
        flex: 0 1 auto;
        margin-left: 88px;
        min-width: 242px;
        text-align: right;
      }
      .action {
        margin-left: 56px;
        min-width: 266px;
        flex: 0 1 auto;
        text-align: right;
        &:empty {
          display: none;
        }
      }
    }
  }
}
.mobile .page-header {
  .main {
    .row {
      flex-wrap: wrap;
      .avatar {
        flex: 0 1 25%;
        margin: 0 2% 8px 0;
      }
      .content,
      .headerContent {
        flex: 0 1 70%;
        .link {
          margin-top: 16px;
          line-height: 24px;
          a {
            font-size: 14px;
            margin-right: 10px;
          }
        }
      }
      .extra {
        flex: 1 1 auto;
        margin-left: 0;
        min-width: 0;
        text-align: right;
      }
      .action {
        margin-left: unset;
        min-width: 266px;
        flex: 0 1 auto;
        text-align: left;
        margin-bottom: 12px;
        &:empty {
          display: none;
        }
      }
    }
  }
}
</style>
